var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFleetIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 185") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mockup6",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fleet",
    transform: "translate(-40.000000, -179.000000)",
    fill: "#CCCCCC"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-185",
    transform: "translate(40.000000, 179.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.08883333,16.8343333 L8.70633333,10.8335 L5.60133333,10.8335 L9.6755,3.3335 L13.4588333,3.3335 L10.3546667,8.3335 L14.2405,8.3335 L6.08883333,16.8343333 Z M9.99966667,0.000166666667 C4.48633333,0.000166666667 -0.000333333333,4.486 -0.000333333333,10.0001667 C-0.000333333333,15.5143333 4.48633333,20.0001667 9.99966667,20.0001667 C15.5138333,20.0001667 19.9996667,15.5143333 19.9996667,10.0001667 C19.9996667,4.486 15.5138333,0.000166666667 9.99966667,0.000166666667 L9.99966667,0.000166666667 Z",
    id: "Fill-2758"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFleetIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/fleet_icon.088ee36c0ec865b7407e320a0ca41a3e.svg";